import React from 'react';

import logoInk from '../../assets/brand/bizvision-logo-ink.png';
import logoWhite from '../../assets/brand/bizvision-logo-white.png';
import markInk from '../../assets/brand/bizvision-mark-ink.png';
import markWhite from '../../assets/brand/bizvision-mark-white.png';
import './logo.scss';

const SOURCES = {
  ink: { lockup: logoInk, mark: markInk },
  white: { lockup: logoWhite, mark: markWhite },
};

/**
 * Official BizVision Tech logo.
 * `variant` picks the ink (light backgrounds) or white (dark backgrounds) art.
 * `type` switches between the full lockup and the standalone mark.
 */
export default function Logo({ variant = 'ink', type = 'lockup', className = '' }) {
  return (
    <img
      src={SOURCES[variant][type]}
      alt="BizVision Tech"
      className={`logo logo--${type} ${className}`.trim()}
      width={type === 'lockup' ? 2774 : 585}
      height={type === 'lockup' ? 582 : 583}
    />
  );
}
